import React, { Component } from 'react'
import {
  Input,
  Button,
  Row,
  Col,
  UncontrolledDropdown, 
  DropdownMenu, 
  DropdownToggle,
  DropdownItem,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from "reactstrap";
import DeleteButton from "../AuthorUIComponents/DeleteButton";
import Select from 'react-select'
import LessonCard from "../LessonCard";

export default class ItemData extends Component {

    state = {
        displayName: "Apostrophes",
        name: "apostrophesEdit",
        subcourseParent: "Challenger",
        subcourseStatus: true,
        tags: null,
        selectedTags: ['hard-difficulty', 'medium-difficulty']
     
      };

    componentWillMount(){
        this.setState({
          ...this.props.item,
          tags: [
          'questionable-answer',
          'test1',
          'test2',
          'test3'
        ] 
        })
    }
    
    showDelete(node) {
        this.setState({ [node.name]: true });
      }
      hideDelete(node) {
        if (!this.state[`${node.name}-clicked`]) {
          this.setState({ [node.name]: false });
        }
      }
      handleClickAway(node) {
        this.setState({
          [`${node.name}-clicked`]: false,
          [node.name]: false
        });
      }

      handleTagSelection = (e) => {
        this.setState({
          selectedTags: [e.target.value , ...this.state.selectedTags],
          tags: this.state.tags.filter(tag => tag !== e.target.value)
        })
      }

      deleteTag = (value) => {
        this.setState({
          selectedTags: this.state.selectedTags.filter(tag => tag !== value),
          tags: [value , ...this.state.tags]
        })
      }

  render() {
      const { itemCode, preview, selectedTags } = this.state

      const colourStyles = {
        control: (styles, { data, isDisabled, isFocused, isSelected }) => {
         return {
            ...styles,
          backgroundColor: isFocused ? '#fff' : '#d6d6d6',
          borderRadius: 0,
          cursor: 'pointer',
          boxShadow: 'none',
          '&:hover': false,
            }
        },
        placeholder: styles => ({ color: '#3e515b' }),
        indicatorSeparator: base => ({
            ...base,
            display: 'none'
        }),
        dropdownIndicator: (styles, { data, isDisabled, isFocused, isSelected }) => ({
            ...styles,
            backgroundColor: isFocused ? '#fff' : '#d6d6d6',
            color: 'hsl(0,0%,60%)'
        })
      };
    return (
        <React.Fragment>
        <LessonCard
          iconClass="info-lesson"
          heading="Item Data"
          isCollapsable
        >
          <Row className="row-lesson">
            <Col colSpan="4" md="4" sm="6">
              <span className="label">Item Code: </span>
            </Col>
            <Col colSpan="8" md="5" sm="6">
              <Input
                className="grey-field"
                value={itemCode}
                onChange={e => {
                  this.setState({
                    itemCode: e.target.value,
                    itemCodeChanged: true
                  });
                }}
                onFocus={e => {
                  //console.log(e.target.value)
                  //this.setState({ displayNameChanged: true })
                }}
              />
              {this.state.itemCodeChanged && (
                <span
                  className="save-input save-icon"
                  onClick={() => this.setState({ itemCodeChanged: false })}
                />
              )}
            </Col>
          </Row>
          <Row className="row-lesson">
            <Col colSpan="4" md="4" sm="6">
              <span className="label">Item Type: </span>
            </Col>
            <Col colSpan="8" md="7" sm="7">
              {/* <Input
                value={this.state.name}
                onChange={e =>
                  this.setState({ name: e.target.value, nameChanged: true })
                }
              /> */}
              <Select 
              value={{label: 'Multiple Choice', value: '1'}}
              options={[{label: 'Multiple Choice', value: '1'}]} 
              className={`item-select`}
              styles={colourStyles}
              />  
              {this.state.nameChanged && (
                <span
                  className="save-input save-icon"
                  onClick={() => this.setState({ nameChanged: false })}
                />
              )}
            </Col>
          </Row>
          <Row className="row-lesson">
            <Col colSpan="4" md="4" sm="6">
              {" "}
              <span className="label">Tags: </span>
            </Col>
            <Col md='7' sm='7'>

            <UncontrolledDropdown>
                <DropdownToggle className='tag-toggle-button' onChange={(e) => console.log(e.target.value)}>
                    <span>Click to add new tag</span>
                </DropdownToggle>
                <DropdownMenu
                    modifiers={{
                    setMaxHeight: {
                        enabled: true,
                        order: 890,
                        fn: (data) => {
                        return {
                            ...data,
                            styles: {
                            ...data.styles,
                            overflow: 'auto',
                            maxHeight: 125,
                            width: 300
                            },
                        };
                        },
                    },
                    }}
                >
                {this.state.tags.map(tag => 
                  <DropdownItem style={{padding: '5px 20px'}} value={`${tag}`} onClick={this.handleTagSelection}>{tag}</DropdownItem>
                )}
                </DropdownMenu>
                </UncontrolledDropdown>
                <div className='selected-tags'>
                {
                  selectedTags ? 
                  selectedTags.map(tag => 
                  <React.Fragment>

                  <div className='tag'>
                    {tag}
                  </div>
                  
                  <DeleteButton handleDelete={() => this.deleteTag(tag)}/>

                  </React.Fragment>
                  ) : null
                }
                </div>
                
            </Col>
          </Row>
          <Row className="row-lesson">
            <Col colSpan="4" md="4" sm="6">
              {" "}
              <span className="label">Nodes: </span>
            </Col>
            <Col colSpan="8" md="5" sm="6">
              {this.props.nodes.map(node => (
                <div>
                  <div
                    className="node-name"
                    onMouseEnter={() => this.showDelete(node)}
                    onMouseLeave={() => this.hideDelete(node)}
                  >
                    {node.name}{" "}
                    {
                      <label
                        className={`delete-parent${
                          this.state[`${node.name}`] ? "-active" : ""
                        }`}
                        onClick={() =>
                          this.setState({ [`${node.name}-clicked`]: true })
                        }
                        onBlur={() => this.handleClickAway(node)}
                      >
                        <DeleteButton
                          handleDelete={() => console.log("Delete Node")}
                          index={node.name}
                        />
                      </label>
                    }
                  </div>
                </div>
              ))}
              <div className="node-btn">
                <Button
                  className="lesson-action-btn"
                  onClick={() => this.props.toggleCard('editNode')}
                >
                  Edit Node
                </Button>
              </div>
            </Col>
          </Row>
          <Row className="row-lesson">
            <Col colSpan="4" md="4" sm="6">
              {" "}
              <span className="label">Preview: </span>
            </Col>
            <Col colSpan="8" md="7" sm="7">
              <div dangerouslySetInnerHTML={{ __html: preview }}></div>
            </Col>
          </Row>
        </LessonCard>
    </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Users/Authors/AuthorItem/ItemData.js